import * as React from 'react'

import { IconSearch } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { GlobalSearchInputFieldStyled } from './styles/GlobalSearchInputFieldStyled'
import { GlobalSearchInputWrapperStyled } from './styles/GlobalSearchInputWrapperStyled'

interface IGlobalSearchInputProps {
  listboxId: string
  query: string
  inputRef: React.RefObject<HTMLInputElement>
  activeDescendantId: string | undefined
  isExpanded: boolean
  onQueryChange: (value: string) => void
  onEnter: () => void
  onNavigateDown: () => void
  onNavigateUp: () => void
}

export const GlobalSearchInput = ({
  listboxId,
  query,
  inputRef,
  activeDescendantId,
  isExpanded,
  onQueryChange,
  onEnter,
  onNavigateDown,
  onNavigateUp,
}: IGlobalSearchInputProps) => {
  const intl = useProcurifyIntl()

  return (
    <GlobalSearchInputWrapperStyled>
      <IconSearch size={16} color='textSecondary' />
      <GlobalSearchInputFieldStyled
        ref={inputRef}
        listboxId={listboxId}
        query={query}
        activeDescendantId={activeDescendantId}
        isExpanded={isExpanded}
        placeholder={intl.formatMessage(messages.inputPlaceholder)}
        ariaLabel={intl.formatMessage(messages.inputAriaLabel)}
        onQueryChange={onQueryChange}
        onEnter={onEnter}
        onNavigateDown={onNavigateDown}
        onNavigateUp={onNavigateUp}
      />
    </GlobalSearchInputWrapperStyled>
  )
}
